import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { IonButton, IonIcon, IonModal } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Nourish questionnaire prompt modal.
 */
@Component({
  selector: 'app-nourish-questionnaire-prompt-modal',
  templateUrl: './prompt-modal.component.html',
  styleUrls: ['./prompt-modal.component.scss'],
  imports: [IonModal, IonButton, IonIcon, TranslateModule]
})
export class NourishQuestionnairePromptModalComponent {
  private readonly router = inject(Router);

  isOpen = input.required<boolean | null>();

  readonly reportType = input<string | null>();
  readonly isOpenChange = output<boolean>();

  /**
   * On did dismiss modal.
   *
   * @memberof NourishQuestionnairePromptModalComponent
   */
  onDidDismissModal(): void {
    this.isOpenChange.emit(false);
  }

  /**
   * On will dismiss modal.
   *
   * @param {CustomEvent} event Event.
   * @memberof NourishQuestionnairePromptModalComponent
   */
  onWillDismissModal(event: CustomEvent): void {
    if (event.detail.role === 'go') {
      this.router.navigate(['questionnaire', 'nourish']);
    }
  }
}
